<!-- eslint-disable -->
<template>
  <v-container class="faq-container">
    <h1 class="text-h4 mb-2">{{ $t('faq.title') || 'Ofte stillede spørgsmål' }}</h1>
    <p class="text-subtitle-1 text-grey mb-6">{{ $t('faq.subtitle') || 'Find svar på de mest almindelige spørgsmål.' }}</p>

    <!-- Loading -->
    <div v-if="loading" class="text-center py-8">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>

    <!-- FAQ Content -->
    <template v-else-if="faqs.length > 0">
      <div v-for="category in faqCategories" :key="category" class="mb-6">
        <!-- Category Header -->
        <h2 v-if="category" class="text-h6 mb-3 d-flex align-center">
          <v-icon class="mr-2" color="primary">mdi-folder-outline</v-icon>
          {{ category }}
        </h2>

        <v-expansion-panels variant="accordion" class="mb-4">
          <v-expansion-panel
            v-for="faq in faqsByCategory(category)"
            :key="faq.faqId"
          >
            <v-expansion-panel-title>
              <v-icon class="mr-3" color="primary" size="small">mdi-help-circle-outline</v-icon>
              <span class="font-weight-medium">{{ faq.question }}</span>
            </v-expansion-panel-title>
            <v-expansion-panel-text>
              <div class="faq-answer" v-html="faq.answer"></div>
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </template>

    <!-- Empty State -->
    <v-card v-else elevation="1" class="text-center pa-8">
      <v-icon size="64" color="grey" class="mb-4">mdi-frequently-asked-questions</v-icon>
      <h3 class="text-h6">{{ $t('faq.empty') || 'Ingen FAQ tilgængelig endnu.' }}</h3>
    </v-card>
  </v-container>
</template>

<script setup>
/* eslint-disable */
import { ref, computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import api from '../services/api'

const { locale } = useI18n()

const faqs = ref([])
const loading = ref(false)

const faqCategories = computed(() => {
  const cats = new Set()
  faqs.value.forEach(f => {
    cats.add(f.category || '')
  })
  return [...cats].sort((a, b) => {
    if (!a) return 1
    if (!b) return -1
    return a.localeCompare(b)
  })
})

const faqsByCategory = (category) => {
  return faqs.value
    .filter(f => (f.category || '') === category)
    .sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0))
}

const loadFaqs = async () => {
  loading.value = true
  try {
    const response = await api.get('/faq', {
      params: { locale: locale.value }
    })
    faqs.value = response.data.items || []
  } catch (error) {
    console.error('Failed to load FAQs:', error)
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  loadFaqs()
})
</script>

<style scoped>
.faq-container {
  max-width: 900px;
  margin: 0 auto;
  padding-top: 2rem;
}

.faq-answer {
  padding: 0.5rem 0;
  line-height: 1.6;
}

.faq-answer :deep(p) {
  margin-bottom: 0.75em;
}

.faq-answer :deep(a) {
  color: rgb(var(--v-theme-primary));
  text-decoration: underline;
}

.faq-answer :deep(ul),
.faq-answer :deep(ol) {
  padding-left: 1.5em;
  margin-bottom: 0.75em;
}

.faq-answer :deep(h3) {
  font-size: 1.1em;
  font-weight: bold;
  margin: 1em 0 0.5em;
}
</style>